// @flow
import { cloneObject } from "@utils/object";
import * as actions from "@modules/integrations/constants/actions";
import * as reducers from "./reducers";
import initialState from "./state";
import type { IntegrationsState } from "@modules/integrations/types";

const handlers = {
  [actions.GetIntegrationApplications]: reducers.setLoading,
  [actions.GetIntegrationApplicationsSuccess]: reducers.onGetApplicationsSuccess,
  [actions.GetIntegrationApplicationsError]: reducers.setLoaded,

  [actions.CreateIntegrationApplication]: reducers.setLoading,
  [actions.CreateIntegrationApplicationSuccess]: reducers.onSaveApplicationSuccess,
  [actions.CreateIntegrationApplicationError]: reducers.setLoaded,

  [actions.UpdateIntegrationApplication]: reducers.setLoading,
  [actions.UpdateIntegrationApplicationSuccess]: reducers.onSaveApplicationSuccess,
  [actions.UpdateIntegrationApplicationError]: reducers.setLoaded,

  [actions.DeleteIntegrationApplication]: reducers.setLoading,
  [actions.DeleteIntegrationApplicationSuccess]: reducers.onDeleteApplicationSuccess,
  [actions.DeleteIntegrationApplicationError]: reducers.setLoaded,

  [actions.GetIntegrationApplicationDetails]: reducers.onGetApplicationDetails,
  [actions.GetIntegrationApplicationDetailsSuccess]: reducers.onGetApplicationDetailsSuccess,

  [actions.GetIntegrationSecretKey]: reducers.setLoading,
  [actions.GetIntegrationSecretKeySuccess]: reducers.onSecretKeySuccess,
  [actions.GetIntegrationSecretKeyError]: reducers.onSecretKeyError,
  [actions.GenerateIntegrationSecretKey]: reducers.setLoading,
  [actions.GenerateIntegrationSecretKeySuccess]: reducers.onSecretKeySuccess,
  [actions.GenerateIntegrationSecretKeyError]: reducers.onSecretKeyError,

  [actions.GetIntegrationOfflineToken]: reducers.setLoading,
  [actions.GetIntegrationOfflineTokenSuccess]: reducers.onOfflineTokenSuccess,
  [actions.GetIntegrationOfflineTokenFailed]: reducers.onOfflineTokenError,
  [actions.GenerateIntegrationOfflineToken]: reducers.setLoading,
  [actions.GenerateIntegrationOfflineTokenSuccess]: reducers.onOfflineTokenSuccess,
  [actions.GenerateIntegrationOfflineTokenError]: reducers.onOfflineTokenError,

  [actions.ToggleIntegrationApplicationFormModal]: reducers.onToggleApplicationFormModal,
  [actions.ToggleIntegrationDeleteModal]: reducers.onToggleDeleteModal,
  [actions.ToggleIntegrationTokenModal]: reducers.onToggleTokenModal,
};

export default (state: IntegrationsState = initialState, action: Object): IntegrationsState => {
  const handler = action && action.type && handlers[action.type];
  if (handler) {
    return handler(cloneObject(state))(action);
  }
  return state;
};
